import BasicApiClass from './classes/BasicApiClass'

export const contactoApi = new BasicApiClass({
    recurso: 'prospecto',
    recursoMulti: 'prospectos'
})

